import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Logo from './../assets/images/logo.png';

const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isDashboardOpen, setIsDashboardOpen] = useState(
        location.pathname.startsWith('/dashboard')
    );
    const [isUsersOpen, setIsUsersOpen] = useState(
        location.pathname.startsWith('/users')
    );
    const [isProductsOpen, setIsProductsOpen] = useState(
        location.pathname.startsWith('/products')
    );
    const [isActionsOpen, setIsActionsOpen] = useState(
        location.pathname.startsWith('/actions')
    );
    const [isCampusOpen, setIsCampusOpen] = useState(
        location.pathname.startsWith('/campus')
    );
    const [isUserControlOpen, setIsUserControlOpen] = useState(
        location.pathname === '/admins' || location.pathname === '/ambassadors'
    );
    const [isUserSubmissionsOpen, setIsUserSubmissionsOpen] = useState(
        location.pathname === '/issues' || location.pathname === '/reported-users'
    );
    const [isAppControlOpen, setIsAppControlOpen] = useState(
        location.pathname === '/app-config' || location.pathname === '/promotional-banners'
    );

    const handleLogout = () => {
        console.log('Logging out...');
        localStorage.clear();
        navigate('/login');
    };

    const toggleDashboard = () => {
        setIsDashboardOpen(!isDashboardOpen);
    };

    const toggleUsers = () => {
        setIsUsersOpen(!isUsersOpen);
    };

    const toggleProducts = () => {
        setIsProductsOpen(!isProductsOpen);
    };

    const toggleActions = () => {
        setIsActionsOpen(!isActionsOpen);
    };

    const toggleCampus = () => {
        setIsCampusOpen(!isCampusOpen);
    };

    const toggleUserControl = () => {
        setIsUserControlOpen(!isUserControlOpen);
    };

    const toggleUserSubmissions = () => {
        setIsUserSubmissionsOpen(!isUserSubmissionsOpen);
    };

    const toggleAppControl = () => {
        setIsAppControlOpen(!isAppControlOpen);
    };

    const isDashboardActive = location.pathname.startsWith('/dashboard');
    const isUserMetricsActive = location.pathname === '/dashboard/user-metrics';
    const isMarketplaceMetricsActive = location.pathname === '/dashboard/marketplace-metrics';
    const isUsersActive = location.pathname.startsWith('/users');
    const isAllUsersActive = location.pathname === '/users';
    const isVerifiedUsersActive = location.pathname === '/users/verified';
    const isPendingUsersActive = location.pathname === '/users/pending';
    const isRejectedUsersActive = location.pathname === '/users/rejected';
    const isProductsActive = location.pathname.startsWith('/products');
    const isAllListingsActive = location.pathname === '/products';
    const isActionsActive = location.pathname.startsWith('/actions');
    const isMyActionsActive = location.pathname === '/actions/my-actions';
    const isAllActionsActive = location.pathname === '/actions/all-actions';
    const isCampusActive = location.pathname.startsWith('/campus');
    const isCampusOverviewActive = location.pathname === '/campus/overview';
    const isAmbassadorOverviewActive =
        location.pathname === '/campus/ambassador-overview' ||
        location.pathname.startsWith('/campus/ambassador-overview/');
    const isReferralPaymentRequestsActive =
        location.pathname === '/campus/referral-payment-requests';
    const isActiveListingsActive = location.pathname === '/products/active';
    const isPendingListingsActive = location.pathname === '/products/pending';
    const isSoldListingsActive = location.pathname === '/products/sold';
    const isRejectedListingsActive = location.pathname === '/products/rejected';
    const isPromotionalBannersActive = location.pathname === '/promotional-banners';
    const isCouponRedemptionsActive = location.pathname === '/coupon-redemptions';
    const isAppConfigActive = location.pathname === '/app-config';
    const isUserControlActive =
        location.pathname === '/admins' || location.pathname === '/ambassadors';
    const isAdminsActive = location.pathname === '/admins';
    const isAmbassadorsPageActive = location.pathname === '/ambassadors';
    const isUserSubmissionsActive =
        location.pathname === '/issues' || location.pathname === '/reported-users';
    const isIssuesActive = location.pathname === '/issues';
    const isReportedUsersActive = location.pathname === '/reported-users';
    const isAppControlActive =
        location.pathname === '/app-config' || location.pathname === '/promotional-banners';

    return (
        <div className="sidebar position-relative">
            <div className="logo">
                <img src={Logo} alt="Logo" width={100} height={100} />
            </div>
            <ul className="menu">
                <li style={{ position: 'relative' }}>
                    <div 
                        onClick={toggleDashboard}
                        style={{ 
                            cursor: 'pointer',
                            padding: '15px 0',
                            borderBottom: '1px solid #e8e8e8',
                            color: isDashboardActive ? '#ff6705' : '#101010'
                        }}
                    >
                        <div className='d-flex justify-content-between align-items-center' style={{ padding: '0 20px' }}>
                            <span>Dashboard</span>
                            <span style={{ fontSize: '10px' }}>
                                {isDashboardOpen ? '▼' : '▶'}
                            </span>
                        </div>
                    </div>
                    {isDashboardOpen && (
                        <ul className="submenu" style={{ 
                            listStyle: 'none', 
                            padding: 0, 
                            margin: 0,
                            backgroundColor: '#f8f9fa'
                        }}>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link 
                                    to="/dashboard/user-metrics"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isUserMetricsActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isUserMetricsActive ? '600' : '400'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isUserMetricsActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isUserMetricsActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    User Metrics
                                </Link>
                            </li>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link 
                                    to="/dashboard/marketplace-metrics"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isMarketplaceMetricsActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isMarketplaceMetricsActive ? '600' : '400'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isMarketplaceMetricsActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isMarketplaceMetricsActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    Marketplace Metrics
                                </Link>
                            </li>
                        </ul>
                    )}
                </li>
                <li style={{ position: 'relative' }}>
                    <div 
                        onClick={toggleUsers}
                        style={{ 
                            cursor: 'pointer',
                            padding: '15px 0',
                            borderBottom: '1px solid #e8e8e8',
                            color: isUsersActive ? '#ff6705' : '#101010'
                        }}
                    >
                        <div className='d-flex justify-content-between align-items-center' style={{ padding: '0 20px' }}>
                            <span>Users</span>
                            <span style={{ fontSize: '10px' }}>
                                {isUsersOpen ? '▼' : '▶'}
                            </span>
                        </div>
                    </div>
                    {isUsersOpen && (
                        <ul style={{ 
                            listStyle: 'none', 
                            padding: 0, 
                            margin: 0,
                            backgroundColor: '#f8f9fa'
                        }}>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link 
                                    to="/users"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isAllUsersActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isAllUsersActive ? '600' : '400'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isAllUsersActive) e.target.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isAllUsersActive) e.target.style.color = '#101010';
                                    }}
                                >
                                    All Users
                                </Link>
                            </li>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link 
                                    to="/users/verified"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isVerifiedUsersActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isVerifiedUsersActive ? '600' : '400'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isVerifiedUsersActive) e.target.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isVerifiedUsersActive) e.target.style.color = '#101010';
                                    }}
                                >
                                    Verified Users
                                </Link>
                            </li>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link 
                                    to="/users/pending"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isPendingUsersActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isPendingUsersActive ? '600' : '400'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isPendingUsersActive) e.target.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isPendingUsersActive) e.target.style.color = '#101010';
                                    }}
                                >
                                    Pending Users
                                </Link>
                            </li>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link 
                                    to="/users/rejected"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isRejectedUsersActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isRejectedUsersActive ? '600' : '400'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isRejectedUsersActive) e.target.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isRejectedUsersActive) e.target.style.color = '#101010';
                                    }}
                                >
                                    Rejected Users
                                </Link>
                            </li>
                        </ul>
                    )}
                </li>
                <li style={{ position: 'relative' }}>
                    <div 
                        onClick={toggleProducts}
                        style={{ 
                            cursor: 'pointer',
                            padding: '15px 0',
                            borderBottom: '1px solid #e8e8e8',
                            color: isProductsActive ? '#ff6705' : '#101010'
                        }}
                    >
                        <div className='d-flex justify-content-between align-items-center' style={{ padding: '0 20px' }}>
                            <span>Products</span>
                            <span style={{ fontSize: '10px' }}>
                                {isProductsOpen ? '▼' : '▶'}
                            </span>
                        </div>
                    </div>
                    {isProductsOpen && (
                        <ul className="submenu" style={{ 
                            listStyle: 'none', 
                            padding: 0, 
                            margin: 0,
                            backgroundColor: '#f8f9fa'
                        }}>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link 
                                    to="/products"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isAllListingsActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isAllListingsActive ? '600' : '400'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isAllListingsActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isAllListingsActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    All Listings
                                </Link>
                            </li>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link 
                                    to="/products/active"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isActiveListingsActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isActiveListingsActive ? '600' : '400'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isActiveListingsActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isActiveListingsActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    Active Listings
                                </Link>
                            </li>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link 
                                    to="/products/pending"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isPendingListingsActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isPendingListingsActive ? '600' : '400'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isPendingListingsActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isPendingListingsActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    Pending Approval
                                </Link>
                            </li>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link 
                                    to="/products/sold"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isSoldListingsActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isSoldListingsActive ? '600' : '400'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isSoldListingsActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isSoldListingsActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    Sold Listings
                                </Link>
                            </li>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link 
                                    to="/products/rejected"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isRejectedListingsActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isRejectedListingsActive ? '600' : '400'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isRejectedListingsActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isRejectedListingsActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    Rejected Listings
                                </Link>
                            </li>
                        </ul>
                    )}
                </li>
                <li style={{ position: 'relative' }}>
                    <div 
                        onClick={toggleActions}
                        style={{ 
                            cursor: 'pointer',
                            padding: '15px 0',
                            borderBottom: '1px solid #e8e8e8',
                            color: isActionsActive ? '#ff6705' : '#101010'
                        }}
                    >
                        <div className='d-flex justify-content-between align-items-center' style={{ padding: '0 20px' }}>
                            <span>Actions</span>
                            <span style={{ fontSize: '10px' }}>
                                {isActionsOpen ? '▼' : '▶'}
                            </span>
                        </div>
                    </div>
                    {isActionsOpen && (
                        <ul className="submenu" style={{ 
                            listStyle: 'none', 
                            padding: 0, 
                            margin: 0,
                            backgroundColor: '#f8f9fa'
                        }}>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link 
                                    to="/actions/my-actions"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isMyActionsActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isMyActionsActive ? '600' : '400'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isMyActionsActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isMyActionsActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    My Actions
                                </Link>
                            </li>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link 
                                    to="/actions/all-actions"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isAllActionsActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isAllActionsActive ? '600' : '400'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isAllActionsActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isAllActionsActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    All Actions
                                </Link>
                            </li>
                        </ul>
                    )}
                </li>
                <li style={{ position: 'relative' }}>
                    <div
                        onClick={toggleUserControl}
                        style={{
                            cursor: 'pointer',
                            padding: '15px 0',
                            borderBottom: '1px solid #e8e8e8',
                            color: isUserControlActive ? '#ff6705' : '#101010',
                        }}
                    >
                        <div className='d-flex justify-content-between align-items-center' style={{ padding: '0 20px' }}>
                            <span>User Control</span>
                            <span style={{ fontSize: '10px' }}>
                                {isUserControlOpen ? '\u25BC' : '\u25B6'}
                            </span>
                        </div>
                    </div>
                    {isUserControlOpen && (
                        <ul className="submenu" style={{
                            listStyle: 'none',
                            padding: 0,
                            margin: 0,
                            backgroundColor: '#f8f9fa',
                        }}>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link
                                    to="/admins"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isAdminsActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isAdminsActive ? '600' : '400',
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isAdminsActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isAdminsActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    Admin
                                </Link>
                            </li>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link
                                    to="/ambassadors"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isAmbassadorsPageActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isAmbassadorsPageActive ? '600' : '400',
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isAmbassadorsPageActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isAmbassadorsPageActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    Ambassador
                                </Link>
                            </li>
                        </ul>
                    )}
                </li>
                <li style={{ position: 'relative' }}>
                    <div
                        onClick={toggleUserSubmissions}
                        style={{
                            cursor: 'pointer',
                            padding: '15px 0',
                            borderBottom: '1px solid #e8e8e8',
                            color: isUserSubmissionsActive ? '#ff6705' : '#101010',
                        }}
                    >
                        <div className='d-flex justify-content-between align-items-center' style={{ padding: '0 20px' }}>
                            <span>User Submissions</span>
                            <span style={{ fontSize: '10px' }}>
                                {isUserSubmissionsOpen ? '\u25BC' : '\u25B6'}
                            </span>
                        </div>
                    </div>
                    {isUserSubmissionsOpen && (
                        <ul className="submenu" style={{
                            listStyle: 'none',
                            padding: 0,
                            margin: 0,
                            backgroundColor: '#f8f9fa',
                        }}>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link
                                    to="/issues"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isIssuesActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isIssuesActive ? '600' : '400',
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isIssuesActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isIssuesActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    Issues
                                </Link>
                            </li>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link
                                    to="/reported-users"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isReportedUsersActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isReportedUsersActive ? '600' : '400',
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isReportedUsersActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isReportedUsersActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    Reported Users
                                </Link>
                            </li>
                        </ul>
                    )}
                </li>
                <li style={{ position: 'relative' }}>
                    <div 
                        onClick={toggleCampus}
                        style={{ 
                            cursor: 'pointer',
                            padding: '15px 0',
                            borderBottom: '1px solid #e8e8e8',
                            color: isCampusActive ? '#ff6705' : '#101010'
                        }}
                    >
                        <div className='d-flex justify-content-between align-items-center' style={{ padding: '0 20px' }}>
                            <span>Campus Management</span>
                            <span style={{ fontSize: '10px' }}>
                                {isCampusOpen ? '▼' : '▶'}
                            </span>
                        </div>
                    </div>
                    {isCampusOpen && (
                        <ul className="submenu" style={{ 
                            listStyle: 'none', 
                            padding: 0, 
                            margin: 0,
                            backgroundColor: '#f8f9fa'
                        }}>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link 
                                    to="/campus/overview"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isCampusOverviewActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isCampusOverviewActive ? '600' : '400'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isCampusOverviewActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isCampusOverviewActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    Campus Overview
                                </Link>
                            </li>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link 
                                    to="/campus/ambassador-overview"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isAmbassadorOverviewActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isAmbassadorOverviewActive ? '600' : '400'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isAmbassadorOverviewActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isAmbassadorOverviewActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    Ambassador Overview
                                </Link>
                            </li>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link
                                    to="/campus/referral-payment-requests"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isReferralPaymentRequestsActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isReferralPaymentRequestsActive ? '600' : '400',
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isReferralPaymentRequestsActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isReferralPaymentRequestsActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    Referral Payment Requests
                                </Link>
                            </li>
                        </ul>
                    )}
                </li>
                <li style={{ position: 'relative' }}>
                    <div
                        onClick={toggleAppControl}
                        style={{
                            cursor: 'pointer',
                            padding: '15px 0',
                            borderBottom: '1px solid #e8e8e8',
                            color: isAppControlActive ? '#ff6705' : '#101010',
                        }}
                    >
                        <div className='d-flex justify-content-between align-items-center' style={{ padding: '0 20px' }}>
                            <span>App Control</span>
                            <span style={{ fontSize: '10px' }}>
                                {isAppControlOpen ? '\u25BC' : '\u25B6'}
                            </span>
                        </div>
                    </div>
                    {isAppControlOpen && (
                        <ul className="submenu" style={{
                            listStyle: 'none',
                            padding: 0,
                            margin: 0,
                            backgroundColor: '#f8f9fa',
                        }}>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link
                                    to="/app-config"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isAppConfigActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isAppConfigActive ? '600' : '400',
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isAppConfigActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isAppConfigActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    App Configurations
                                </Link>
                            </li>
                            <li style={{ borderBottom: '1px solid #e8e8e8' }}>
                                <Link
                                    to="/promotional-banners"
                                    className="submenu-link"
                                    style={{
                                        display: 'block',
                                        padding: '12px 20px 12px 50px',
                                        color: isPromotionalBannersActive ? '#ff6705' : '#101010',
                                        textDecoration: 'none',
                                        fontWeight: isPromotionalBannersActive ? '600' : '400',
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isPromotionalBannersActive) e.currentTarget.style.color = '#ff6705';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isPromotionalBannersActive) e.currentTarget.style.color = '#101010';
                                    }}
                                >
                                    Promotional Banners
                                </Link>
                            </li>
                        </ul>
                    )}
                </li>
                <li>
                    <Link to="/coupon-redemptions" style={{ 
                        display: 'block',
                        padding: '15px 0',
                        borderBottom: '1px solid #e8e8e8',
                        color: isCouponRedemptionsActive ? '#ff6705' : '#101010',
                        textDecoration: 'none'
                    }}>
                        <div className='d-flex justify-content-start align-items-center' style={{ padding: '0 20px' }}>Coupon Redemptions</div>
                    </Link>
                </li>
                <li 
                    className="logout"
                    onClick={handleLogout}
                    style={{ cursor: 'pointer' }}
                >
                    <div style={{ 
                        display: 'block',
                        padding: '15px 0',
                        borderBottom: '1px solid #e8e8e8',
                        borderTop: '1px solid #e8e8e8',
                        color: '#101010'
                    }}>
                        <div className='d-flex justify-content-start align-items-center' style={{ padding: '0 20px' }}>Logout</div>
                    </div>
                </li>
            </ul>
        </div>
    );
}

export default Sidebar;
